/**
 * GENERATED CODE
 * this file is generated by the 'process-icons' script.
 */
import React from 'react';
import { createSvgIcon } from '../utils';
export default createSvgIcon(React.createElement("g", { style: { transform: 'scaleY(-1)', transformOrigin: '50% 50%' } },
    React.createElement("path", { d: "M49.5996 315.84l206.4 -206.399l206.4 206.399l21.4395 -21.4395l-227.84 -227.841l-227.84 227.841z" })), 'ExpandArrow', '0.00195312 64 512 512');
//# sourceMappingURL=ExpandArrowIcon.js.map